module.exports = __webpack_public_path__ + "images/location-marker.5a168a2b40a74c2626c5.png";